import { tryDuo2026Metadata } from '@proton/payments/core/coupon-config/configs/try-duo-2026';

import type { CouponConfig } from './interface';

export const tryDuo2026Config: CouponConfig = {
    ...tryDuo2026Metadata,
};
